// extracted by css-extract-rspack-plugin
export default {"container":"CreateIndexDialog-module__container__nz7bS","header":"CreateIndexDialog-module__header__rPb7f","headerSubtext":"CreateIndexDialog-module__headerSubtext__OJu3a"};